exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media(min-width:768px){.fts-information-modal .fts-form-container .fts-form-item .fts-form-element-container.compact-form-design .fts-form-label{min-width:100px;width:100px}}", ""]);

// exports
